import React, { Component } from 'react'
import { observer } from 'mobx-react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Card from '@material-ui/core/Card'

class WidgetBox extends Component {
  render () {
    const { label, action, className, children, customClass } = this.props
    const classes = classNames('widget-box', className)

    return (
      <Card className={classes}>
        <div className='widget-box__top-bar'>
          <h2>{label}</h2>
          {action ? (
            <div className={`widget-box__top-bar__action ${customClass ?? ''}`}>
              {action}
            </div>
          ) : null}
        </div>
        {children}
      </Card>
    )
  }
}

WidgetBox.propTypes = {
  label: PropTypes.string,
  action: PropTypes.node,
  theme: PropTypes.string,
  className: PropTypes.string,
  customClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default observer(WidgetBox)
